<div class="modal-container">
  <h5 class="title"> Is your information on file still correct? </h5>
  <hr style="border: 1px solid rgba(0,0,0,0.1); width: 70%; margin: 10px auto;">

  <div class="info">
    <p class="sub-bold-text"> Email </p>
    <p> {{this.userSummary?.email || 'N/A'}} </p>
    <br />
  </div>

  <div class="info">
    <p class="sub-bold-text"> Phone Number </p>
    <p> {{this.userSummary?.phone_number || 'N/A'}}</p>
    <br />
  </div>

  <div class="info">
    <p class="sub-bold-text"> Address </p>
    <p> {{this.userSummary?.shipping_info?.mailing_address || 'N/A'}}</p>
    <br />
  </div>

  <div class="info">
    <p class="sub-bold-text"> Preferred Language </p>
    <p> {{this.userSummary?.d_info?.preferred_language || 'N/A'}}</p>
    <br />
  </div>

  @if (this.userSummary.market == 'New York, NY') {
    <div class="info">
      <p class="sub-bold-text"> TLC Number </p>
      <p> {{this.userSummary?.d_info?.tlc_number || 'N/A'}}</p>
      <br />
    </div>
  }

  @if (this.userSummary.market == 'New York, NY') {
    <div class="info">
      <p class="sub-bold-text"> TLC Expiration Date </p>
      <p> {{this.userSummary?.d_info?.tlc_expiration_date || 'N/A'}}</p>
      <br />
    </div>
  }
  <br />

  <div>
    <a
      (click)="this.markContactInfoUpdated()"
      mat-button
      class="btn btn-pink-filled"
      style="margin-right: 1.5em;"
      >
      Everything Looks Good
    </a>
    <a
      routerLink="/my-account/driver-info"
      mat-button
      class="btn btn-pink"
      (click)="this.close()"
      >
      Update Personal Info
    </a>
    <br />
  </div>

</div>
